<template>
  <a
    v-if="manufacturer_count"
    :href="`/manufacturers/?from=${from}`"
    target="_blank"
    class="pBig col-md-7 text-center active-color fw-bold"
  >
    {{ $t('companyCount', { count: manufacturer_count }, manufacturer_count) }}
  </a>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    from: {
      type: String,
    }
  },
  computed: {
    ...mapState('counters', [
      'manufacturer_count'
    ])
  }
}
</script>
